
import { Loader } from "lucide-react";

export function LoadingScreen({ message = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Loader className="h-12 w-12 animate-spin text-primary" />
      <p className="mt-4 text-gray-600">{message}</p>
    </div>
  );
}
